import request from "@/utils/request"

export const graffiti = (params) => {
    return request({
        url: "/app/im_link/graffiti",
        method: "post" ,   
        data: params
    })
}


export const newGraffiti = (params) => {
    return request({
        url: "/app/im_link/v2/graffiti",
        method: "post" ,   
        data: params
    })
}

export const saveGraffiti = (params) => {
    return request({
        url: "/app/im_link/save_graffiti_result",
        method: "post" ,   
        data: params
    })
}

export const genResult = (params) => {
    return request({
        url: "/app/im_link/gen_result",
        method: "post" ,   
        data: params
    })
}

export const getSignUrl = (params) => {
    return request({
        url: "/app/im_link/get_signUrl",
        method: "post" ,   
        data: params
    })
}

export const uploadImgs = (params) => {
    return request({
        url: "/app/im_link/upload_graffiti",
        method: "post" ,   
        data: params
    })
}